import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'
import { addClass } from '~/common/utils/html'

interface Props {
  show: boolean
  onClick(): void
}

const NavigationCover = ({show, onClick}: Props) => {
  return (
    <div className={styles.cover + addClass(styles.show, show)} onClick={onClick}/>
  )
}

export default NavigationCover